import { forwardRef } from 'react';

const ScrollContainerV2 = forwardRef(({ id, className, isScreenScroll, children, style }, ref) => {
  return (
    <div ref={ref} id={id} className={`comp-scroll-container-v2 ${className || ''} ${isScreenScroll ? 'screen-scroll' : ''}`} style={style}>
      {children}
    </div>
  );
});

ScrollContainerV2.displayName = 'ScrollContainerV2';

export default ScrollContainerV2;
